import _objectSpread from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import dayjs from 'dayjs';
import { mapActions } from 'vuex';
import localeMixin from '@/locales/mixin.js';
export default {
  mixins: [localeMixin],
  data: function data() {
    var data = {
      timeInterval: null,
      time: dayjs().format('HH:mm:ss'),
      // 表单
      formLogin: {
        username: '',
        password: ''
      },
      // 表单校验
      rules: {
        username: [{
          required: true,
          message: 'please insert username',
          trigger: 'blur'
        }],
        password: [{
          required: true,
          message: 'please insert password',
          trigger: 'blur'
        }]
      }
    };
    data.formLogin.username = this.$env.VUE_APP_USER || '';
    data.formLogin.password = this.$env.VUE_APP_PASSWORD || '';
    return data;
  },
  mounted: function mounted() {
    var _this = this;

    this.timeInterval = setInterval(function () {
      _this.refreshTime();
    }, 1000);
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.timeInterval);
  },
  methods: _objectSpread(_objectSpread({}, mapActions('d2admin/user', ['login'])), {}, {
    refreshTime: function refreshTime() {
      this.time = dayjs().format('HH:mm:ss');
    },

    /**
     * @description 提交表单
     */
    // 提交登录信息
    submit: function submit() {
      var _this2 = this;

      this.$refs.loginForm.validate(function (valid) {
        if (valid) {
          // 登录
          _this2.login({
            username: _this2.formLogin.username,
            password: _this2.formLogin.password,
            to: _this2.$route.query.redirect || '/'
          });
        } else {
          // 登录表单校验失败
          _this2.$message.error('from check error,please check');
        }
      });
    }
  })
};